import { render, staticRenderFns } from "./ProjectionMonthlyChart.vue?vue&type=template&id=f9bb8bbc&"
import script from "./ProjectionMonthlyChart.vue?vue&type=script&lang=js&"
export * from "./ProjectionMonthlyChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports